import { AbstractControl, ValidationErrors } from "@angular/forms";
import { GetPasswordComplexitySettingsResult } from "@modules/api/get-password-complexity-settings-result.generated";

/**
 * Passwords form validator function factory.
 * @param control The control to validate
 */
export function meetsPasswordComplexity(settings?: GetPasswordComplexitySettingsResult): ((control: AbstractControl) => ValidationErrors | null) {
    if (!settings) {
        return control => { return null };
    }

    return control => {
        var password: string = control.value;

        // Doesn't meet minimum length
        if (password && password.length < settings.minLength) {
            return {
                passwordcomplexity: true,
                minlength: true,
            };
        }

        // Exceeds maximum length
        if (password && password.length > settings.maxLength) {
            return {
                passwordcomplexity: true,
                maxlength: true,
            };
        }

        // Doesn't satisfy minimum number of patterns
        if (password && settings.minPatternsFulfilled > 0 && (!settings.patterns || settings.patterns.filter(pattern => { return new RegExp(pattern.pattern || '').test(password); }).length < settings.minPatternsFulfilled)) {
            return {
                passwordcomplexity: true,
                minpatterns: true,
            }
        }

        return null;
    }
}
